import { render, staticRenderFns } from "./ChildRegistrationForm.vue?vue&type=template&id=8b93b7ee&scoped=true"
import script from "./ChildRegistrationForm.vue?vue&type=script&lang=ts"
export * from "./ChildRegistrationForm.vue?vue&type=script&lang=ts"
import style0 from "./ChildRegistrationForm.vue?vue&type=style&index=0&id=8b93b7ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b93b7ee",
  null
  
)

export default component.exports